<h1 class="component-header">
    <div class="row">
        <div class="col-6">
            <div class="input-group">
                <input type="text" class="form-control" formControlName="CustomFormTitle" readonly/>
                <span class="input-group-append">
                    <button type="button" (click)="onCustomFormRemoved()" class="btn btn-warning btn-xsm m-1">
                        <i class="fas fa-trash-alt"></i>
                    </button>
                </span>
            </div>
        </div>
        <div class="col-6 text-right" formGroupName="Paging">
            <paetep-search 
                formControlName="SearchBy"
                [isBusy]="isBusy"
                (keyup.enter)="onSearchBy()"
                (onBlur)="onSearchBy()"
                (onReset)="onReset()"
            ></paetep-search>
        </div>
    </div>
</h1>
<paetep-custom-form-selector formControlName="CustomFormId" [customFormSelectorDTOs]="pagedResponse?.Results ?? []" [busy]="reloadQueue.isLoading" (onFieldSelected)="onFieldSelected($event)" (onCustomFormSelected)="onCustomFormSelected($event)"></paetep-custom-form-selector> 
<div *ngIf="pagedResponse" class="content mt-2">
    <div class="row">
        <div class="col-sm-12 text-right">
            <edl-pagination *ngIf="pagedResponse.TotalNumberPages > 1"
                            [collectionSize]="pagedResponse.TotalCount"
                            [page]="getPagingControl('CurrentPage')?.value"
                            [pageSize]="pagedResponse.Limit"
                            (pageChange)="onPageChange($event)"></edl-pagination>
        </div>
    </div>
</div>


